import service from '../services/apiService'

export const state = () => ({
  iframeUrl: undefined,
  loading: false,
  userId: '',
  operatorId: '',
  teenpattiIframrUrl: 'https://d2.fawk.app/#/splash-screen',
  error: {},
  livecardGameData: []
})

export const mutations = {
  set_data(state, data) {
    state.sessionId = data
  },

  isMobile() {
    if (
      /Android|webOS|iPhone|iPad|iPod|BlackBerry|IEMobile|Opera Mini/i.test(
        navigator.userAgent
      )
    ) {
      return true
    } else {
      return false
    }
  },
  set_error(state, data) {
    state.error = data
  },
  set_loading(state, data) {
    state.loading = data
  },
  set_data_livecard_game(state, data) {
    state.livecardGameData = data
  }
}

export const actions = {
  // session id
  async getPremiumSportbookSessionID({ commit }) {
    try {
      commit('set_loading', true)
      const response = await service.apiCallWithUserCancelTransactionWithHeader(
        '/casino/live/session/open',
        {
          id: '1444005',
          type: 'SPORTSBOOK'
        }
      )
      if (response.data) {
        commit('set_data', response.data.result)
      }

      commit('set_loading', false)
    } catch (error) {
      commit('set_error', error)
      commit('set_loading', false)
    }
  },
  async destorySessionID({ commit }) {
    try {
      commit('set_loading', true)
      const response = await service.apiCallWithUserCancelTransactionWithHeader(
        '/casino/live/session/close'
      )
      if (response.data) {
        console.log('set_data', response.data)
      }

      commit('set_loading', false)
    } catch (error) {
      console.log(error)
      commit('set_error', error)
      commit('set_loading', false)
    }
  }
}
